module.exports = __webpack_public_path__ + "static/media/business-plan.6739fdd6.png";